import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/public/Landing";
import Calculator from "@/pages/public/Calculator";
import Booking from "@/pages/public/Booking";
import ScanConsignment from "@/pages/public/ScanConsignment";
import Galeri from "@/pages/public/Galeri";
import QcDashboard from "@/pages/erp/QcDashboard";
import DocsDashboard from "@/pages/erp/DocsDashboard";
import PackingDashboard from "@/pages/erp/PackingDashboard";
import ShippingDashboard from "@/pages/erp/ShippingDashboard";
import Login from "@/pages/Login";
import ApprovalView from "@/pages/public/ApprovalView";
import MachineSale from "@/pages/public/MachineSale";
import MachineSaleList from "@/pages/public/MachineSaleList";
import PublicCatalog from "@/pages/public/PublicCatalog";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import ErpLayout from "@/components/erp/ErpLayout";
import Dashboard from "@/pages/erp/Dashboard";
import Customers from "@/pages/erp/Customers";
import Quotations from "@/pages/erp/Quotations";
import Invoices from "@/pages/erp/Invoices";
import Projects from "@/pages/erp/Projects";
import WorkOrders from "@/pages/erp/WorkOrders";
import WoBoard from "@/pages/erp/WoBoard";
import Store from "@/pages/erp/Store";
import Production from "@/pages/erp/Production";
import SalesDashboard from "@/pages/erp/SalesDashboard";
import PettyCash from "@/pages/erp/PettyCash";
import Tax from "@/pages/erp/Tax";
import Bank from "@/pages/erp/Bank";
import PublicService from "@/pages/public/PublicService";
import Rapor from "@/pages/erp/Rapor";
import Teknisi from "@/pages/erp/Teknisi";
import Stock from "@/pages/erp/Stock";
import Assets from "@/pages/erp/Assets";
import RackView from "@/pages/erp/RackView";
import Employees from "@/pages/erp/Employees";
import Attendance from "@/pages/erp/Attendance";
import Payroll from "@/pages/erp/Payroll";
import Finance from "@/pages/erp/Finance";
import WoBudget from "@/pages/erp/WoBudget";
import BookingAdmin from "@/pages/erp/BookingAdmin";
import Settings from "@/pages/erp/Settings";
import Audit from "@/pages/erp/Audit";
import Workflow from "@/pages/erp/Workflow";
import DesignDashboard from "@/pages/erp/DesignDashboard";
import TeamCalendar from "@/pages/erp/TeamCalendar";
import ProductionDashboard from "@/pages/erp/ProductionDashboard";
import Finishing from "@/pages/erp/Finishing";
import Purchasing from "@/pages/erp/Purchasing";
import VirtualOffice from "@/pages/erp/VirtualOffice";
import Deliveries from "@/pages/erp/Deliveries";
import DesignEstimator from "@/pages/erp/DesignEstimator";
import Tasks from "@/pages/erp/Tasks";
import Consignments from "@/pages/erp/Consignments";
import Receivables from "@/pages/erp/Receivables";
import BonusSales from "@/pages/erp/BonusSales";
import Survey from "@/pages/Survey";
import Catalog from "@/pages/erp/Catalog";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=") && !location.pathname.startsWith("/katalog")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/calculator" element={<Calculator />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/survey/:token" element={<Survey />} />
      <Route path="/tv/wo" element={<WoBoard />} />
      <Route path="/approval/:token" element={<ApprovalView />} />
      <Route path="/mesin-dijual" element={<MachineSaleList />} />
      <Route path="/katalog" element={<PublicCatalog />} />
      <Route path="/servis/:token" element={<PublicService />} />
      <Route path="/mesin-dijual/:token" element={<MachineSale />} />
      <Route path="/scan/tb/:cid" element={<ScanConsignment />} />
      <Route path="/galeri/:token" element={<Galeri />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/app" element={<ErpLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="virtual-office" element={<VirtualOffice />} />
        <Route path="crm" element={<Customers />} />
        <Route path="consignments" element={<Consignments />} />
        <Route path="receivables" element={<Receivables />} />
        <Route path="bonus-sales" element={<BonusSales />} />
        <Route path="store" element={<Store />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="quotations" element={<Quotations />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="design-estimator" element={<DesignEstimator />} />
        <Route path="projects" element={<Projects />} />
        <Route path="workorders" element={<WorkOrders />} />
        <Route path="design-dashboard" element={<DesignDashboard />} />
        <Route path="office-rules" element={<Navigate to="/app/team-calendar?tab=rules" replace />} />
        <Route path="leave" element={<Navigate to="/app/team-calendar?tab=leave" replace />} />
        <Route path="team-calendar" element={<TeamCalendar />} />
        <Route path="production-dashboard" element={<ProductionDashboard />} />
        <Route path="finishing" element={<Finishing />} />
        <Route path="qc" element={<QcDashboard />} />
        <Route path="dokumentasi" element={<DocsDashboard />} />
        <Route path="packing" element={<PackingDashboard />} />
        <Route path="pengiriman" element={<ShippingDashboard />} />
        <Route path="rak/:rid" element={<RackView />} />
        <Route path="production" element={<Production />} />
        <Route path="sales" element={<SalesDashboard />} />
        <Route path="kpi" element={<Navigate to="/app/settings?tab=kpi" replace />} />
        <Route path="petty-cash" element={<PettyCash />} />
        <Route path="tax" element={<Tax />} />
        <Route path="bank" element={<Bank />} />
        <Route path="rapor" element={<Rapor />} />
        <Route path="teknisi" element={<Teknisi />} />
        <Route path="stock" element={<Stock />} />
        <Route path="assets" element={<Assets />} />
        <Route path="machines" element={<Navigate to="/app/teknisi?tab=machines" replace />} />
        <Route path="hr" element={<Employees />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="finance" element={<Finance />} />
        <Route path="wo-budget" element={<WoBudget />} />
        <Route path="booking" element={<BookingAdmin />} />
        <Route path="settings" element={<Settings />} />
        <Route path="audit" element={<Audit />} />
        <Route path="workflow" element={<Workflow />} />
        <Route path="purchasing" element={<Purchasing />} />
        <Route path="delivery" element={<Deliveries />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
